import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { TRUMP_ACCOUNTS_URL } from "@constants";
import { Flow } from "@ctypes";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useGoalFlow } from "@hooks";
import { Translations, i18n } from "@i18n";
import { openInNewTab } from "@utils";

export const TrumpAccountSetupRoute = () => {
  const {
    goalProps: { flow },
  } = useGoalFlow();

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.TrumpAccountSetupRouteTitle),
    hideLogout: flow !== Flow.Onboarding,
    cta: {
      primary: {
        title: i18n.t(Translations.TrumpAccountSetupRoutePrimaryCTA),
        onClick: () => openInNewTab(TRUMP_ACCOUNTS_URL),
      },
    },
  };

  return (
    <OnboardingLayout {...props}>
      <BodySmall>{i18n.t(Translations.TrumpAccountSetupRouteBody)}</BodySmall>
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
